
import React from 'react';
import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const EventCalendar: React.FC = () => {
  const endpoint = '/events-calendar';
  const title = 'Calendário';

  const { projectHash, eventHash } = useParams<Record<string, any>>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },

    title: { ref: 'title', column: 'title', label: 'Título' },
    url: { ref: 'url', column: 'url', label: 'URL' },
    description: { ref: 'description', column: 'description', label: 'Descritivo', show: false },


    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    image: {
      model: 'imageSingle',
      type: 'input',
      name: 'image',
      label: 'Foto',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },
    start_at: { model: 'datePicker', type: 'text', name: 'start_at', label: 'Data' },


    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    local: { model: 'input', type: 'text', name: 'local', label: 'Local' },
    subtitle: { model: 'richText', type: 'text', name: 'subtitle', label: 'Subtítulo' },
    description: { model: 'richText', type: 'text', name: 'description', label: 'Descritivo' },
    nested_authors: { model: 'input', type: 'text', name: 'nested_authors', label: 'Autores' },

    video: { model: 'input', type: 'text', name: 'video', label: 'Link de Vídeo' },

    dates: {
      model: 'ArrayInputIncluder',
      name: 'dates',
      type: 'date',
      label: 'Datas do evento',
      defaultValue: [],
    },
    status: {
      model: 'selectSimple',
      name: 'status',
      label: 'Ativo?',
      defaultValue: 'Sim',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ]
    },
    files: {
      model: 'imageGalleryInput',
      type: 'input',
      name: 'files',
      label: 'Arquivos',
      list: [
        { label: 'Arquivo', name: 'url' },
        { label: 'Título', name: 'title' },


      ],

    },
    buttons: {
      model: 'jsonListMultiple',
      type: 'text',
      name: 'buttons',
      label: 'Botões',
      list: {
        title: { label: 'Título', name: 'title' },
        link: { label: 'Link', name: 'link' },
        class_name: { label: 'Tipo de botão', name: 'class_name' },
      },
    },

    images: {
      model: 'imageGalleryInput',
      type: 'input',
      name: 'images',
      label: 'Imagens',
      list: [
        { label: 'Imagem', name: 'url' },
        { label: 'Título', name: 'title' },

        { label: 'Link', name: 'link_url' },

      ],
    },
    /*   theme_data: {
        model: 'jsonList',
        type: 'text',
        name: 'theme_data',
        label: 'Personalização',
        list: [
          { label: 'Fundo', name: 'background' },
          { label: 'Cor da linha', name: 'line_color' },
          { label: 'Cor do título', name: 'title_color' },
          { label: 'Cor do Texto', name: 'text_color' },
        ],
      }, */
  };

  const formSchemaUpdate = {


    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default EventCalendar;
